// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class TrackingHistoryAPI extends MainAPI {
	/**
	 * @param {*} trackingDetails contains tracking details
	 * @return {object} tracking history details
	 */
	async getTrackingDetails(trackingDetails) {
		return API.get(`${ENDPOINTS.GET_TRACKING}?${queryString.stringify(trackingDetails)}`);
	}

	/**
	 * @param {*} petId
	 * @return no content
	 */
	async connectPetTracking(petId) {
		return API.put(`${ENDPOINTS.PUT_TRACKING}/${petId}/connect`);
	}

	/**
	 * @param {*} petId
	 * @return no content
	 */
	async disconnectPetTracking(petId) {
		return API.put(`${ENDPOINTS.PUT_TRACKING}/${petId}/disconnect`);
	}

	/**
	 * @param {*} petId, serial number
	 * @return no content
	 */
	async putSerialNumberTracking(petId, serialNumber) {
		return API.put(`${ENDPOINTS.PUT_TRACKING}/${petId}/device`, serialNumber);
	}

	/**
	 * @param {*} petId, serial number
	 * @return no content
	 */
	async deleteSerialNumberTracking(petId, serialNumber) {
		return API.delete(`${ENDPOINTS.DELETE_TRACKING}/${petId}/device`, serialNumber);
	}
}
export default new TrackingHistoryAPI();
